import OdometerComponent from "./OdometerComponent";
import "odometer/themes/odometer-theme-minimal.css";
import { counters } from "./facts";
import React, { useState, useEffect } from "react";
import "./hero.css";

export default function Facts() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Ensure component is mounted before rendering counters
    setMounted(true);
  }, []);

  return (
    <section className="section-realty tf-spacing-1">
      <style>{`
        .quote-container {
          display: flex;
          flex-direction: column;
          gap: 40px;
          max-width: 100%;
          margin: 0 auto 40px;
        }
        
        .quote-card {
          position: relative;
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 20px;
          padding: 20px;
          border-radius: 16px;
          border: 1.5px solid rgba(255, 255, 255, 0.2);
        }
        
        .profile-image-container > div {
          width: 120px;
          height: 180px;
        }
        
        .quote-content {
          flex: 1;
          text-align: center;
          position: relative;
        }
        
        .quote-text {
          font-size: 14px;
        }
        
        .name-heading {
          font-size: 20px;
        }
        
        @media (min-width: 768px) {
          .quote-container {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
          }
          
          .quote-card {
            flex-direction: row;
            align-items: center;
            gap: 30px;
            padding: 25px;
          }
          
          .profile-image-container > div {
            width: 160px;
            height: 260px;
          }
          
          .quote-content {
            text-align: left;
          }
          
          .quote-text {
            font-size: 17px;
          }
          
          .name-heading {
            font-size: 26px;
          }
        }
      `}</style>
      <div className="tf-container">
        <div className="row">
          <div className="col-12">
            <div className="heading-section text-center" style={{ marginBottom: '60px' }}>

              {/* Container for both Quote Sections */}
              <div className="quote-container">

                {/* Left Quote Section with Image and Text */}
                <div className="quote-card">

                  {/* Left Side - Profile Image */}
                  <div className="profile-image-container" style={{
                    position: 'relative',
                    flexShrink: 0
                  }}>
                    <div style={{
                      overflow: 'hidden',
                    }}>
                      <img
                        src="/img/vidarbha/nitin.svg"
                        alt="Shri Nitin Ji Gadkari"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                  </div>

                  {/* Right Side - Quote and Details */}
                  <div className="quote-content">

                    <p className="quote-text" style={{
                      margin: '0 0 25px 0',
                      color: 'rgba(255, 255, 255, 0.95)',
                      fontFamily: '"Rubik", sans-serif',
                      fontWeight: '400',
                      // fontStyle: 'italic'
                    }} className="quote-text">                      <style jsx>{`
                        @media (min-width: 768px) {
                          .quote-text {
                            font-size: 17px !important;
                          }
                        }
                      `}</style>
                      "                    Vidarbha is steadily emerging as a key driver of industrial expansion, with AID’s focused initiatives playing a crucial role in advancing this momentum. Strengthened by growing investments, expanding opportunities, and a dynamic business ecosystem, the region is well-positioned to attract investors.
                      "                  </p>

                    {/* Name and Designation */}
                    <div style={{ marginTop: '20px' }}>
                      <p style={{
                        fontSize: '16px',
                        fontWeight: '400',
                        color: 'rgba(200, 200, 200, 0.85)',
                        marginBottom: '-17px',
                        fontFamily: '"Rubik", sans-serif',
                        lineHeight: '1'
                      }}>
                        Envisioned by
                      </p>
                      <h3 style={{
                        fontSize: '26px',
                        fontWeight: '600',
                        color: '#ffffff',
                        marginTop: '-8px',
                        marginBottom: '5px',
                        fontFamily: '"Rubik", sans-serif',
                        position: 'relative',
                        display: 'inline-block'
                      }}>
                        Shri Nitin Ji Gadkari
                        <div style={{
                          position: 'absolute',
                          bottom: '-3px',
                          left: '0',
                          width: '60%',
                          height: '2px',
                          background: 'rgba(255, 255, 255, 0.5)'
                        }}></div>
                      </h3>
                      <p style={{
                        fontSize: '16px',
                        fontWeight: '400',
                        color: 'rgba(200, 200, 200, 0.85)',
                        marginTop: '5px',
                        fontFamily: '"Rubik", sans-serif'
                      }}>
                        Union Minister, MoRTH, GOI
                      </p>
                    </div>
                  </div>

                </div>

                {/* Right Quote Section with Image and Text */}
                <div className="quote-card">

                  {/* Left Side - Profile Image */}
                  <div className="profile-image-container" style={{
                    position: 'relative',
                    flexShrink: 0
                  }}>
                    <div style={{
                      overflow: 'hidden',
                    }}>
                      <img
                        src="/img/vidarbha/devandra.svg"
                        alt="Shri Devendra Ji Fadnavis"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                  </div>

                  {/* Right Side - Quote and Details */}
                  <div className="quote-content">
                    {/* Quote Icon */}
                    {/* <div style={{
                      fontSize: '80px',
                      color: "#ffffff",
                      fontFamily: 'Georgia, serif',
                      lineHeight: '0.8',
                      marginBottom: '2px'
                    }}>
                      "
                    </div> */}

                    <p className="quote-text" style={{
                      margin: '0 0 25px 0',
                      color: 'rgba(255, 255, 255, 0.95)',
                      fontFamily: '"Rubik", sans-serif',
                      fontWeight: '400',
                      // fontStyle: 'italic'
                    }}>
                      "Vidarbha is on the path to becoming a powerful engine of industrial growth, and AID's dedicated efforts are accelerating this transformation. With rising investments, new opportunities, and a rapidly evolving ecosystem, the region is ready to welcome national and global investors with confidence."
                    </p>

                    {/* Name and Designation */}
                    <div style={{ marginTop: '20px' }}>
                      <p className="designation-text" style={{
                        fontWeight: '400',
                        color: 'rgba(200, 200, 200, 0.85)',
                        marginBottom: '-17px',
                        fontFamily: '"Rubik", sans-serif',
                        lineHeight: '1'
                      }}>
                        Supported by
                      </p>
                      <h3 className="name-heading" style={{
                        fontWeight: '600',
                        color: '#ffffff',
                        marginTop: '-8px',
                        marginBottom: '5px',
                        fontFamily: '"Rubik", sans-serif',
                        position: 'relative',
                        display: 'inline-block'
                      }}>
                        Shri Devendra Ji Fadnavis
                        <div style={{
                          position: 'absolute',
                          bottom: '-3px',
                          left: '0',
                          width: '60%',
                          height: '2px',
                          background: 'rgba(255, 255, 255, 0.5)'
                        }}></div>
                      </h3>
                      <p className="designation-text" style={{
                        fontWeight: '400',
                        color: 'rgba(200, 200, 200, 0.85)',
                        marginTop: '5px',
                        fontFamily: '"Rubik", sans-serif'
                      }}>
                        Hon'ble Chief Minister, Maharashtra
                      </p>
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </div>

          {/* Counter Cards */}
          <div className="tf-grid-layout-2 lg-col-4" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '20px' }}>
            {mounted && counters.map((counter, index) => (
              <div key={index} className="counter-item style-1">
                <div className="count text-center">
                  <div className="counter-number">
                    <div
                      className={`odometer odometer-auto-theme ${counter.class}`}
                    >
                      <OdometerComponent key={`counter-${index}-${mounted}`} max={counter.value} />
                    </div>
                    {counter.suffix && (
                      <span className="sub">{counter.suffix}</span>
                    )}
                  </div>
                  <p className="text-1 text_white text-center">{counter.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
